import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import Save_Date_Fall from '../../component/Fall/Save_Date_Fall';
import axios from 'axios';
import Info_Fall from '../../component/Fall/Info_Fall';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Fall from '../../component/Fall/Main_Fall';
import CallInfo from '../../component/CallInfo';
import ParentInfo from '../../component/Info/ParentInfo';

const LeeHwaYeon = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "김진혁❤️이화연";
    const openDesc = "10월 25일 토요일 오후 12시\n채림웨딩홀 6층 단독홀";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/255/thumb.jpg";
    
    // const parents = [
    //     {groom : "박삼용의 아들"},
    //     {bride : "최재선 · 김연순의 손녀"}
    // ] 

    const placeTelNum = "032-228-8000";

    const lng = 126.7818618;
    const lat = 37.4846357;

    const forCar = "네비게이션 이용시 : “채림웨딩홀부페” 또는 \n“부천시 원미구 심곡동 173-1”\n\n경인고속도로 부천 IC에서 약 15분 소요\n서울 외곽순환도로 시흥 IC에서 약 15분 소요\n\n주차 : 전용주차장 3시간 무료";
    const forBus = "부천북부역 하차\n3, 5, 5-3, 5-4, 5-5, 8, 11, 12-1, 23-1, 50, 66, 70-2, 75, \n606, 661";
    const forSubway = "지하철 1호선 부천역 (북부역광장 방면) \n- 3번, 4번, 7번출구 이용"

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    const conceptStyle = {
        concept: "FALL",
        titleColor: "#000000",
        pointColor: "#AB5934",
        btnBgColor: "#AB5934",
        fontColor: "#000000",
        btnFontColor: "#ffffff",
        chatBgColor: "#F4F4F4",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Milchella"
    }

    const title = "우리 결혼합니다."

    const msg1 = "가을의 선물 같은 우리 결혼, \n만난 지 4년 만에 새로운 시작을 합니다. \n함께 축하해 주세요.";

    const groomAccountList = [
        {
            role: "신랑",
            name: "김진혁",
            bank: "국민은행",
            accountNumber : "476102-01423302",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "김성조",
            bank: "농협은행",
            accountNumber : "351-0375-8007-53",
            isKakao : false
        },
        {
            role: "신랑 모",
            name: "유미선",
            bank: "농협은행",
            accountNumber : "461-12-357803",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "이화연",
            bank: "카카오뱅크",
            accountNumber : "3333-01-8413525",
            isKakao : false
        }
        ,{
            role: "신부 부",
            name: "이철한",
            bank: "카카오뱅크",
            accountNumber : "3333-22-7851685",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "김명숙",
            bank: "기업은행",
            accountNumber : "081-092496-01025",
            isKakao : false
        }
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "김진혁",
            call: "010-5100-7362"
        }
        ,{
            role: "신랑 부",
            name: "김성조",
            call: "010-5955-7362"
        },
        {
            role: "신랑 모",
            name: "유미선",
            call: "010-2813-7362"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "이화연",
            call: "010-5641-7362"
        }
        ,{
            role: "신부 부",
            name: "이철한",
            call: "010-4148-0082"
        },
        {
            role: "신부 모",
            name: "김명숙",
            call: "010-7127-3855"
        }
    ]

    const parentInfo = {
        groom: {
            dad: { name: "박삼용", isDeceased: false },
            // mom: { name: "", isDeceased: false },
            role: "장남",
        },
        bride: {
            dad: { name: "최명성", isDeceased: false },
            // mom: { name: "", isDeceased: false },
            role: "장녀",
        }
    };


    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // Park Seo Young -> Park Seo young
    const toLowerCaseString = (str) => {
        const parts = str.split(" ");
        if (parts.length < 2) return str; // 성과 이름이 없으면 그대로 반환

        // 첫 단어(성)는 그대로 유지
        const firstPart = parts[0];

        // 두 번째 단어 이후로 처리
        const restParts = parts.slice(1).map((part, index) =>
            index === 0
                ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() // 첫 단어만 첫 글자 대문자
                : part.toLowerCase() // 나머지는 소문자로 변환
        );

        return `${firstPart} ${restParts.join(" ")}`;
    };
    

    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#000000"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} />
                    <Main_Fall brideNameEn={getFirstNameEn(weddingData.groomNameEn)} groomNameEn={getFirstNameEn(weddingData.brideNameEn)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <Save_Date_Fall weddingData={weddingData} color={conceptStyle.pointColor} />
                    <Info_Fall weddingData={weddingData} conceptStyle={conceptStyle} />
                    <Letter title={title} msg1={msg1} conceptStyle={conceptStyle} />
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    <CallInfo marginTop={"0px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring groomName={getFirstKoName(weddingData.brideName)} brideName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"153px"} hotoHeight={"235px"} gap={"4px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                        <Location_Desc forCar={forCar} forSubway={forSubway} forBus={forBus} conceptStyle={conceptStyle}/>
                        <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                        <Footer />
                </>
            )}
        </div>
    );
    
};

export default LeeHwaYeon;